<template>
  <div>
    <el-table
      :data="currentList"
    >
      <el-table-column
        prop="coinType"
        label="币种">
      </el-table-column>
      <el-table-column
        label="日期">
        <template slot-scope="scope">
          <span>{{scope.row.rateDate | moment('YYYY-MM-DD')}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="年利率">
        <template slot-scope="scope">
          <span>{{scope.row.yearRate}}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="操作">
        <template slot-scope="scope">
          <el-button 
            type="primary" 
            circle 
            icon="el-icon-edit"
            @click="handleUpdate(scope.row)"
          ></el-button>
          <!--<el-button 
            type="danger" 
            circle 
            icon="el-icon-delete"
            @click="handleRemove(scope.row.id)"
          ></el-button>-->
        </template>
      </el-table-column>
    </el-table>
    <pagination
      :size="pagination.size"
      :page="pagination.page"
      :total="totalCount"
      @pageChanged="handlePageChanged"
      >
    </pagination>
    <current-detail :current="current"></current-detail>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import CurrentDetail from '../detail';
import Pagination from 'components/pagination';

export default {
  name: 'CurrentList',
  components: {
    CurrentDetail,
    Pagination
  },
  data() {
    return {
      current: {}
    };
  },
  computed: {
    ...mapState('currentSetting', ['currentList', 'pagination', 'totalCount'])
  },
  methods: {
    ...mapMutations('currentSetting', ['toggleDetailDialogVisible']),
    ...mapActions('currentSetting', ['list', 'remove']),
    handleUpdate(current) {
      this.toggleDetailDialogVisible(true);
      this.current = current;
    },
    handlePageChanged(pagination) {
      this.$emit('refresh', pagination);
    },
    handleRemove(id) {
      this.$confirm('确认删除此内容吗？', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.remove(id).then(() => {
            this.$message.success('删除成功！');
            this.list();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="less" scoped>
</style>
